import React from 'react'
import styled from '@emotion/styled/macro'
import { Link } from 'react-router-dom'
import mq from 'mediaQuery'

import ENSLogo from '../assets/ensIconLogo.svg'
import LogoTyped from '../assets/TypeLogo'

const IconLogo = styled('img')`
  width: 40px;
  ${mq.medium`
    width: 45px
  `}
`

const LogoContainer = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
  width: auto;

  ${mq.medium`
    width: 200px;
  `}
`

const StyledSpan = styled('span')`
  @import url('https://fonts.cdnfonts.com/css/counter-strike');
  font-family: 'Counter-Strike', sans-serif;
  color: #E8E8FD;
  font-size: 38px;
  padding-left: 5px;
  margin-top: 20px;
`


const Logo = ({ color, className, to = '' }) => (
  <LogoContainer className={className} to={to}>
    <IconLogo src={ENSLogo} />
    {/*Text Color*/}
    <StyledSpan>
      ANS
    </StyledSpan>
    {/* <LogoTyped color={color} /> */}
  </LogoContainer>
)

export default Logo
